import React from "react";
import type { FieldValues } from "react-hook-form";
import { useController } from "react-hook-form";

import { FieldLabel, Input } from "@braze/beacon-core";

import useI18nNamespace from "@services/useI18nNamespace";

import type { WorkEmailInputFieldProps } from "./types";

export const WorkEmailInputField = <FormValues extends FieldValues = FieldValues>({
  name,
  label,
  control,
  onKeyDown,
  disabled,
}: WorkEmailInputFieldProps<FormValues>): React.ReactElement => {
  const { t } = useI18nNamespace("free-trial-registration");

  const {
    field,
    fieldState: { error, invalid, isTouched },
  } = useController({
    name,
    control,
  });

  return (
    <FieldLabel
      label={label}
      htmlFor={name}
      status="danger"
      data-cy="emailField"
      statusText={error?.message}
      infoIconPopoverContent={t(
        "popover-content",
        "For the best trial experience, please use a company email address. Personal accounts and aliases are not allowed."
      )}
    >
      <Input
        id={name}
        placeholder={t("placeholder", "Enter your work email")}
        fullWidth
        {...field}
        invalid={invalid}
        disabled={disabled}
        onKeyDown={onKeyDown}
        onChange={(e) => {
          field.onChange(e.target.value);
          if (isTouched) {
            field.onBlur();
          }
        }}
      />
    </FieldLabel>
  );
};
